
import { useRoute } from 'vue-router'
import { ref, onBeforeMount } from 'vue'
import { getOfficialSheetSongVersionInfo } from '@/services/songs'
import config from '@/config'
import { songType, songSheetType } from '@/utils/dataMap/song'

export default {
  name: 'VersionDetail',
  setup () {
    const route = useRoute()
    const formState = ref({
      song_type: 0,
      sheet_type: 0,
      tags: []
    })
    onBeforeMount(async () => {
      formState.value = await getOfficialSheetSongVersionInfo(route.params.versionId)
    })

    return {
      history,
      formState,
      config,
      songType,
      songSheetType
    }
  }
}
